import { useEffect, useState } from "react";
import { ReportType } from "../Reports/Reports";
import { Reportable } from "../Reports/ReportCreation";
import { GET } from "../api/BackendApi";
import { Participant, Result, GetParticipantDto, GetResultsDto } from "../api/Dtos";
import { useGlobalContext } from "../Layout/GlobalState";




export function useReportData(currentReportType: ReportType): [Array<Reportable>, boolean] {
  const [participants, setParticipants] = useState<Array<Participant>>([]);
  const [results, setResults] = useState<Array<Result>>([]);

  const [reportables, setReportables] = useState<Array<Reportable>>([]);
  const [dataLoaded, setDataLoaded] = useState(false);

  const globalContext = useGlobalContext();

  // Get participants from backend
  useEffect(() => {
    setDataLoaded(false);
    if (globalContext.competition) {
        if (currentReportType === ReportType.START_LIST || currentReportType === ReportType.START_NUMBER_LIST) {
            if (participants.length > 0) {
                setReportables(participants);
                setDataLoaded(true);
            }
            else {
                GET.allParticipants(globalContext.competition.id, globalContext.competition.disciplines, globalContext.competition.startgroups).then(
                    (response: GetParticipantDto) => {
                        setParticipants(response.participants);
                        setReportables(response.participants);
                        setDataLoaded(true);
                    }
                );
            }
        }
        else if (currentReportType === ReportType.RESULT_LIST) {
            if (results.length > 0) {
                setReportables(results);
                setDataLoaded(true);
            }
            else {
                GET.allReportableResults(globalContext.competition.tag, globalContext.competition.startgroups)
                .then(
                    (response: GetResultsDto) => {
                        setResults(response.results);
                        setReportables(response.results);
                        setDataLoaded(true);
                    }
                );
            }
        }
    }
  }, [globalContext.competition, currentReportType]);
  return [reportables, dataLoaded];
}